import React from "react";

import styled from "styled-components";

export const Form = styled.form``;

export default function FormContainer(props) {
  return (
    <>
      <div className="mdn-Col-xs-12 mdn-Col-md-9 mdn-Col-lg-6">
        <Form {...props}>{props.children}</Form>
      </div>
    </>
  );
}
